import { Link } from 'react-router-dom';
import { Badge } from '../ui/badge';
import { ArrowLeft, ShieldAlert } from 'lucide-react';
import SocialShare from '../SocialShare';

const categoryColors = {
  music: 'bg-purple-500/10 text-purple-500 border-purple-500/20',
  comedy: 'bg-orange-500/10 text-orange-500 border-orange-500/20',
  sports: 'bg-cyan-500/10 text-cyan-500 border-cyan-500/20',
  wedding: 'bg-pink-500/10 text-pink-500 border-pink-500/20',
  weddings: 'bg-pink-500/10 text-pink-500 border-pink-500/20',
  nightlife: 'bg-primary/10 text-primary border-primary/20',
  festivals: 'bg-rose-500/10 text-rose-500 border-rose-500/20',
  arts: 'bg-red-500/10 text-red-500 border-red-500/20',
  food: 'bg-amber-500/10 text-amber-500 border-amber-500/20',
  business: 'bg-slate-500/10 text-slate-500 border-slate-500/20',
  awards: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
  exhibition: 'bg-teal-500/10 text-teal-500 border-teal-500/20',
};

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1563841930606-67e2bce48b78?auto=format&fit=crop&q=80&w=1600';

export function EventHero({ event, imageSrc, imageLoaded }) {
  const displayImage = imageSrc || FALLBACK_IMAGE;

  return (
    <>
      {/* Back button */}
      <Link
        to="/events"
        className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-6 transition-colors"
        data-testid="back-to-events"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Events
      </Link>

      {/* Hero Image */}
      <div className="relative aspect-[21/9] overflow-hidden rounded-2xl mb-8 bg-muted">
        {!imageLoaded && (
          <div className="absolute inset-0 bg-gradient-to-br from-muted to-muted/50 animate-pulse" />
        )}
        <img
          src={displayImage}
          alt={event.title}
          className={`w-full h-full object-cover transition-opacity duration-300 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onError={(e) => {
            e.target.src = FALLBACK_IMAGE;
          }}
        />
        {/* Category Badge */}
        <div className="absolute top-4 left-4 flex gap-2">
          <Badge 
            variant="secondary" 
            className={`${categoryColors[event.category] || 'bg-primary/10 text-primary border-primary/20'} capitalize px-3 py-1`}
          >
            {event.category}
          </Badge>
        </div>
        
        {/* Non-Refundable Badge */}
        {event.is_non_refundable && (
          <Badge 
            variant="destructive"
            className="absolute top-4 right-4 bg-red-500/90 hover:bg-red-500 flex items-center gap-1"
          >
            <ShieldAlert className="w-3 h-3" />
            Non-Refundable
          </Badge>
        )}
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        
        {/* Title Overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight drop-shadow-lg">
              {event.title}
            </h1>
            <SocialShare 
              eventTitle={event.title}
              eventUrl={window.location.href}
            />
          </div>
        </div>
      </div>
    </>
  );
}
